import React from 'react'
import ChatMessage from './ChatMessage';
import NoDataFound from '../../../../../component/common/NoDataFound';

const ChatModal = (props) => {
    return (
        <div className='card w-100 rounded-0'>
            <div className='card-body bg-light'>
                <div className='row'>
                    <div className="card h-xl-100">
                        <div className="card-body pb-0 pt-0">
                            <div className='row header'>
                                <div className='col-md-7'></div>
                                <div className='col-md-5'>
                                    <div className="d-flex justify-content-between pt-3">
                                        <span className="fw-bold text-gray-600 fs-6">Indent</span>
                                        <span className="fw-bold text-gray-600 fs-6">Entity</span>
                                        <span className="fw-bold text-gray-600 fs-6">Information</span>
                                        <span className="fw-bold text-gray-600 fs-6">Action</span>
                                    </div>
                                </div>
                            </div>
                            <div className="scroll-y me-n5 pe-5">
                                <div className='row'>
                                    {props.data.map((item, index) => (
                                        <ChatMessage item={item} chat_cession={props.chat_cession} front_user={props.front_user} key={index} />
                                    ))}
                                    {props.data.length == 0 &&<tr>
                                    <td colSpan="10" className="text-center">
                                        <NoDataFound className="w-30" setHtml="No Data found" />
                                    </td>
                                    </tr>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChatModal;